import {
  DEFAULT_SIZE
} from "./chunk-BHEPBW5D.mjs";
import {
  CheckboxV2
} from "./chunk-LHJ3RNGC.mjs";
import {
  cn
} from "./chunk-DYSUVPH5.mjs";

// src/components/list-item/list-item-content.tsx
import React, { cloneElement } from "react";
var iconSizes = {
  sm: { width: 18, height: 18 },
  md: { width: 20, height: 20 },
  lg: { width: 24, height: 24 }
};
var ListItemContent = ({
  label,
  labelTruncated = false,
  labelWeight = "bold",
  description,
  image,
  controlPosition,
  size = DEFAULT_SIZE,
  className,
  leftIcon,
  rightIcon,
  isSelected = false,
  ...props
}) => {
  const iconProps = iconSizes[size ?? DEFAULT_SIZE];
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: cn(
        "flex items-center gap-2.5",
        {
          "gap-4": size === "lg"
        },
        className
      ),
      ...props
    },
    controlPosition === "left" && /* @__PURE__ */ React.createElement(CheckboxV2, { checked: isSelected, className: "shrink-0 self-start" }),
    image,
    leftIcon && cloneElement(leftIcon, { ...iconProps }),
    /* @__PURE__ */ React.createElement("div", { className: "flex flex-1 flex-col gap-1 overflow-hidden" }, typeof label === "string" ? /* @__PURE__ */ React.createElement(
      "p",
      {
        className: cn({
          "my-label-sm": size !== "lg" && labelWeight === "bold",
          "my-body-md-bold": size === "lg" && labelWeight === "bold",
          "my-body-sm": size !== "lg" && labelWeight === "normal",
          "my-body-md": size === "lg" && labelWeight === "normal",
          truncate: labelTruncated
        })
      },
      label
    ) : label, typeof description === "string" ? /* @__PURE__ */ React.createElement(
      "p",
      {
        className: cn("text-foreground-subtle", {
          "my-body-xs": size !== "lg",
          "my-body-sm": size === "lg"
        })
      },
      description
    ) : description),
    rightIcon && cloneElement(rightIcon, { ...iconProps }),
    controlPosition === "right" && /* @__PURE__ */ React.createElement(CheckboxV2, { checked: isSelected, className: "shrink-0" })
  );
};

export {
  ListItemContent
};
